module.exports = __webpack_public_path__ + "img/example_rabbit.8dfab712.png";